<template>
  <div
    :class="{
      'card-badge': true,
      'card-badge--red': color === 'red',
      'card-badge--blue': color === 'blue',
      'card-badge--gray': color === 'gray',
    }"
  >
    <slot />
    <p class="card-badge__text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'CardBadge',
  props: {
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String, // red | blue | gray
      required: false,
      default: 'red',
    },
  },
}
</script>

<style lang="scss">
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.card-badge {
  border-radius: 4px;
  padding: 2px 4px;
  display: inline-flex;
  align-items: center;
  color: $White;

  &--red {
    background-color: $PlainRed;
  }

  &--blue {
    background-color: lightskyblue;
    color: $Dark100;
  }

  &--gray {
    background-color: $LGray3;
    color: $Dark100;
  }
}

.card-badge__text {
  font-size: 11px;
  line-height: 1.2;

  @include media-breakpoint-up(md) {
    font-size: 12px;
  }
}
</style>
